import { createApiService } from "@/core/api/apiService";
import {
  WebsiteLogoUploadDtoSchema,
  type BusinessWebsiteDto,
  type UpdateBusinessWebsiteDto,
  type WebsiteLogoUploadDto,
} from "../types/businessWebsiteTypes";

export function createBusinessWebsiteApiService() {
  const api = createApiService("businesses");

  return {
    getByBusinessId: (businessId: string, signal?: AbortSignal): Promise<BusinessWebsiteDto | null> =>
      api.get<BusinessWebsiteDto | null>(`/${businessId}/website`, { signal }),
    update: (businessId: string, dto: UpdateBusinessWebsiteDto): Promise<BusinessWebsiteDto> =>
      api.put<BusinessWebsiteDto>(`/${businessId}/website`, dto),
    uploadLogo: async (businessId: string, file: File): Promise<WebsiteLogoUploadDto> => {
      const dto = await api.post<WebsiteLogoUploadDto>(`/${businessId}/website/logo-upload`, {
        content_type: file.type,
        file_size: file.size,
      });
      const upload = WebsiteLogoUploadDtoSchema.parse(dto);
      const response = await fetch(upload.upload_url, {
        method: "PUT",
        headers: { "Content-Type": file.type },
        body: file,
      });
      if (!response.ok) throw new Error(`Couldn't upload your logo (${response.status}). Try again.`);
      return upload;
    },
  };
}

export const businessWebsiteApiService = createBusinessWebsiteApiService();
